module.exports = __webpack_public_path__ + "static/img/huaxiafenmo2.d98efda6.png";